import { createFileRoute, notFound } from '@tanstack/react-router'
import { applicationDetailQueryOptions } from '../-query/query-options'
import { ApplicationDetailPage } from './-components/application-detail-page'

export const Route = createFileRoute(
	'/(private)/bando/$residenceId/domande/$submissionId/'
)({
	// The loader reads a student's personal data and logs the access: a hover
	// on a link must not run it, only opening the page.
	preload: false,
	loader: async ({ context, params }) => {
		try {
			await context.queryClient.ensureQueryData({
				...applicationDetailQueryOptions(
					params.residenceId,
					params.submissionId
				),
				revalidateIfStale: true
			})
		} catch (error) {
			// An application of another residence answers as if it did not exist.
			if (
				typeof error === 'object' &&
				error !== null &&
				'code' in error &&
				(error.code === 'application_submission_not_found' ||
					error.code === 'residence_not_found')
			) {
				throw notFound()
			}
			throw error
		}
	},
	component: AdminApplicationDetail
})

function AdminApplicationDetail() {
	const { residenceId, submissionId } = Route.useParams()
	return (
		<ApplicationDetailPage
			residenceId={residenceId}
			submissionId={submissionId}
		/>
	)
}
